import { initialMenuState, IMenuState } from '../state/menu.state';
import { MenuActions, EMenuActions } from '../actions/menu.actions';


export const menuReducers = (
  state = initialMenuState,
  action: MenuActions
): IMenuState => {
  switch (action.type) {
    case EMenuActions.GetMenuSuccess: {
      return {
        ...state,
        menu: action.payload
      };
    }
    case EMenuActions.GetMenu: {
      return {
        ...state,
        dateMenu: action.payload
      };
    }

    default:
      return state;
  }
};
